import React, { Component } from 'react';
import LabelWithText from '../../../components/molecules/LabelWithText';
import Label from '../../../components/atoms/Label';

export default ({ title, dataDetail }) => {
  let col = { label : 'col-md-3', text : 'col-md-9' }
  // console.log('====================================');
  // console.log({ dataDetail });
  // console.log('====================================');
  return(
    <div>
      <div className='container-title'>
        <Label value={`${title}`} className='label-menu'/>
      </div>
      <div>
        <LabelWithText label = {'Nama Bank'} text = {dataDetail.bankName ? dataDetail.bankName : "-"} col={col} />
        <LabelWithText label = {'No. Rekening'} text = {dataDetail.accountNumber ? dataDetail.accountNumber : "-"} col={col} />
        <LabelWithText label = {'Nama Pemilik Rekening'} text = {dataDetail.accountHolderName ? dataDetail.accountHolderName : "-"} col={col} />
        <LabelWithText label = {'Cabang'} text = {dataDetail.bankBranch ? dataDetail.bankBranch : "-"} col={col} />
        <LabelWithText label = {'Kota'} text = {dataDetail.bankCity ? dataDetail.bankCity : "-"} col={col} />
      </div>
    </div>
  )
}